<template>
  <header class="header">
    <div id="nav">
      <!-- As a heading -->
      <b-navbar variant="faded" type="light" >
        <b-navbar-brand tag="h1" class="mb-0">
          <div class="logo">
            <img :src="logo" min-width="300px" />
          </div>
        </b-navbar-brand>
      </b-navbar>
    </div>
  </header>
</template>
<script>
export default {
  name: "header",
  props:['logo']
};
</script>
<style scoped>
/* .logo {
} */
/* .header {
  background: #333;
  color: #fff;
  text-align: center;
  padding: 10px;
}

.header a {
  color: white;
  padding-right: 5px;
} */
</style>
